import * as ActionTypes from 'state/types'

const initialState = {
  endpoints: [],
  message: null,
  isRequesting: false,
  socketReconnectionError: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ActionTypes.SOCKET_INFO_REQUEST}_START`: {
      return {
        ...state,
        isRequesting: true
      }
    }

    case `${ActionTypes.SOCKET_INFO_REQUEST}_SUCCESS`: {

      return {
        ...state,
        isRequesting: false,
        endpoints: action.response.payload.endpoints
      }
    }

    case `${ActionTypes.SOCKET_INFO_REQUEST}_FAIL`: {
      return {
        ...state,
        endpoints: [],
        message: null,
        isConnected: false,
        isRequesting: false
      }
    }
    case ActionTypes.SOCKET_RECONNECTION_ERROR: {
      return {
        ...state,
        socketReconnectionError: true
      }
    }

    default:
      return state
  }
}
